module.exports = __webpack_public_path__ + "img/57_22.637ffbfb.png";